import { FETCH_TRIGGER } from './actions';

const initialState = {
  fetchTriggerCall: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRIGGER:
      return {
        ...state,
        fetchTriggerCall: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
